import { h } from '@stencil/core';

const Warning = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.134 3.89999C11.5189 3.23333 12.4811 3.23333 12.866 3.89999L20.4871 17.1C20.872 17.7667 20.3908 18.6 19.621 18.6H4.37898C3.60918 18.6 3.12806 17.7667 3.51296 17.1L11.134 3.89999Z" fill="#F3CD44"/>
        </svg>
    );
}

export default Warning;
